import { Injectable } from "@angular/core";
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class EbetService {
    constructor(
        private httpService: HttpService,
        private AppConfig: AppConfig
        
    ) { }

    //登录ebet
    loginEbet() {
        let url = AppConfig.GetProdUrl() + "/Ebet/LoginEbet";
        let par = {};
        return this.httpService.post(url, par);
    }


    /**
     *ebet转账
     * 0：向ebet转入，1：从ebet转出
     * @param {*} amount
     * @param {*} flag
     * @returns
     * @memberof EbetService
     */
    transfer(amount, flag) {
        let url = flag == '0' ? AppConfig.GetProdUrl() + "/Ebet/TransferToEbet" : AppConfig.GetProdUrl() + "/Ebet/TransferFromEbet";
        let par = flag == '0' ? { Money: amount, Type: 0 } : { Money: amount, Type: 1 };
        return this.httpService.post(url, par);
    }

    //判断开启关闭
    ebetStatus() {
        let url = AppConfig.GetProdUrl() + "/Ebet/EbetisOpen";
        return this.httpService.post(url, {});
    }

    getTransferStatus() {
        let url = AppConfig.GetProdUrl() + "/Report/GetDictions?CodeType=EbetTran";
        return this.httpService.get(url);
    }

    //获取转账记录
    getTransferList(params) {
        let url = AppConfig.GetProdUrl() + "/Ebet/GetTransferList";
        let par = { RecordCode: params.RecordCode, StartDate: params.StartDate, EndDate: params.EndDate, PageIndex: params.PageIndex, PageSize: params.PageSize, Status: params.Status, Type: params.Type };
        return this.httpService.post(url, par);
    }

    //获取游戏记录
    getEbetBetList(params) {
        let url = AppConfig.GetProdUrl() + "/Ebet/GetBettingList";
        let par = { StartDate: params.StartDate, EndDate: params.EndDate, PageIndex: params.PageIndex, PageSize: params.PageSize, BetHistoryId: params.GameId };
        return this.httpService.post(url, par);
    }

    //获取ebet余额
    getEbetBalance() {
        let url = AppConfig.GetProdUrl() + "/Ebet/GetBalance";
        return this.httpService.post(url, {});
    }

}


// WEBPACK FOOTER //
// ./src/services/ebet.service.ts